import React from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";

import theme from "styles/theme";
import { AdicionarUnidadeProvider } from "features/adicionar-unidade/hooks/useAdicionarUnidade";
import { AuthProvider } from "hooks/authHook";
import { MFAContextProvider } from "hooks/useMFA";
import { QuickBillProvider } from "features/boleto-rapido/hooks/useQuickBill";
import { TourProvider } from "hooks/useTour";
import { store } from "../store";

const AppProviders = ({ children }) => (
  <Provider store={store}>
    <QuickBillProvider>
      <AuthProvider>
        <MFAContextProvider>
          <TourProvider>
            <AdicionarUnidadeProvider>
              <ThemeProvider theme={theme}>
                <CookiesProvider>
                  <ToastContainer
                    position="top-right"
                    autoClose={10000}
                    hideProgressBar={false}
                    rtl={false}
                    newestOnTop
                    closeOnClick
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                  />
                  {children}
                </CookiesProvider>
              </ThemeProvider>
            </AdicionarUnidadeProvider>
          </TourProvider>
        </MFAContextProvider>
      </AuthProvider>
    </QuickBillProvider>
  </Provider>
);

export default AppProviders;
